module.exports = __webpack_public_path__ + "img/home.ee6c332b.svg";